import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap/lib';
import { Link } from 'react-router-dom';
import { getBlackFridayCountdownFull } from 'helpers/BlackFridayHelper';
import styles from './PricingPromotionBanner.module.scss';

const PricingPromotionBanner = ({ message, color, link }) => {
  const [timeLeft, setTimeLeft] = useState('');

  const isBlackFridayBanner =
    message &&
    (message.includes('BLACKFRIDAY10') || message.includes('Black Friday'));

  useEffect(() => {
    // Only show countdown for Black Friday banner
    if (!isBlackFridayBanner) {
      return;
    }

    // Initial calculation
    setTimeLeft(getBlackFridayCountdownFull());

    // Update every second
    const timer = setInterval(() => {
      setTimeLeft(getBlackFridayCountdownFull());
    }, 1000);

    return () => clearInterval(timer);
  }, [message]);

  const classes = [
    styles.banner,
    color ? styles[color] : styles.primary,
    styles.open,
  ].join(' ');

  const content = (
    <>
      {message}
      {isBlackFridayBanner && timeLeft && <strong>&nbsp;{timeLeft}</strong>}
    </>
  );

  return (
    <Col id="pricing-promotion-banner" className={classes}>
      <div className={styles.message}>
        {link ? (
          <Link
            to={link}
            style={{
              display: 'inline-block',
              verticalAlign: 'middle',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            {content}
          </Link>
        ) : (
          <span style={{ display: 'inline-block', verticalAlign: 'middle' }}>
            {content}
          </span>
        )}
      </div>
    </Col>
  );
};

PricingPromotionBanner.propTypes = {
  message: PropTypes.string,
  color: PropTypes.string,
  link: PropTypes.string,
};

export default PricingPromotionBanner;
